export enum AccountsFilterType {
  Name = 1,
  BPNumber = 2,
  Contact = 3,
  ChildName1 = 4
}
